module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/SnowDepth/Tokyo_SnowDepth_MRI_RCP85_End.png";